import PropTypes from 'prop-types';
import React from 'react';
import Link from 'react-router/lib/Link';
import classNames from 'classnames';

const ErrorComponent = ({ is500Error }) =>
  <div
    className={classNames(
      'api-errors-container',
      is500Error && 'is-500-error'
    )}
  >
    <Link to="/">
      <div className="r29-logo" />
    </Link>
    <div className="error-video">
      <div className="error-text">
        <h1>
          {
            is500Error
              ? 'Something went wrong :('
              : 'Sorry, we couldn\'t find that page.'
          }
        </h1>
        <p>
          {
            is500Error
              ? 'Uh oh. We\'re not sure what happened here, but you can bet we\'re getting to the bottom of it.'
              : 'Let\'s find you something even more awesome.'
          }
        </p>
        <Link to="/">
          <button>{'Today\'s Top Stories'}</button>
        </Link>
      </div>
      <video loop autoPlay className="bgvid">
        <source type="video/webm"
          src="https://www.refinery29.com/file/665/error-office-tour.webm"
        />
        <source type="video/mp4"
          src="https://www.refinery29.com/file/666/error-office-tour.mp4"
        />
      </video>
    </div>

    <footer className="error">
      <ul>
        <li className="copyright"
          dangerouslySetInnerHTML={{ __html: '&copy; 2018 Refinery29' }}
        />
        <li>
          <Link to="/en-us/terms-and-conditions">{'Terms'}</Link>
        </li>
        <li>
          <Link to="/en-us/privacy">{'Privacy'}</Link>
        </li>
        <li>
          <a href="https://corporate.r29.com/">{'About'}</a>
        </li>
        <li>
          <a href="https://corporate.r29.com/press">{'Press'}</a>
        </li>
        <li>
          <a href="mailto:advertising@refinery29.com">{'Advertising'}</a>
        </li>
        <li>
          <a href="https://corporate.r29.com/careers">{'Jobs'}</a>
        </li>
        <li>
          <a href="mailto:feedback@refinery29.com">{'Feedback'}</a>
        </li>
        <li>
          <Link to="/refinery29-news">{'R29 News'}</Link>
        </li>
        <li>
          <Link to="/archives" rel="nofollow">{'Archives'}</Link>
        </li>
        <li>
          <Link to="/rss.xml" rel="nofollow">{'RSS'}</Link>
        </li>
      </ul>
    </footer>
  </div>;

ErrorComponent.propTypes = {
  is500Error: PropTypes.bool.isRequired
};

export default ErrorComponent;
